
import Insurance from './insurance';

const Vehicle = () => {
    return(
        <div>
          <Insurance/>
        </div>
  )        
}

export default Vehicle;